// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2OiT_","selected":"Chip_selected__1kRLw"};